import * as Dfns from 'date-fns/fp';
import { makeMemoizedGetter } from '../../utils/data';
import { BAD_DAY_COUNT, PRETTY_DATE_FORMAT } from './invalid-rotations-constants';

export const TODAY = Dfns.format('yyyy-MM-dd')(new Date());

export const toPrettyDate = (date: string) => Dfns.format(PRETTY_DATE_FORMAT)(Dfns.parseISO(date));

// Whole calendar days from now until the bad day (positive = future).
const getDaysUntil = (date: string) =>
  Dfns.differenceInCalendarDays(new Date())(Dfns.parseISO(date));

export const getIsImminent = makeMemoizedGetter({
  calculate: (date: string) => getDaysUntil(date) <= BAD_DAY_COUNT
});

// Short, scannable "when does this air" label for a rotation row.
export const getRelativeBadDay = (date: string): string => {
  if (date === TODAY) return 'runs today';
  const days = getDaysUntil(date);
  if (days <= 0) return toPrettyDate(date);
  if (days === 1) return 'in 1 day';
  if (days <= BAD_DAY_COUNT) return `in ${days} days`;
  return toPrettyDate(date);
};

export const formatAdServer = (adServer: string) => (adServer === 'ft' ? 'Flashtalking' : adServer);
